var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.cardItems.length > 0
    ? _c("div", { ref: "carousel" }, [
        _c(
          "section",
          { staticStyle: { position: "relative" } },
          [
            _c(
              "ACarousel",
              {
                staticClass: "featured-swiper",
                attrs: {
                  options: _vm.swiperOptions,
                  "hide-arrows": !this.carouselSettings.arrows.value,
                  "hide-pagination": !this.carouselSettings.pills.value,
                },
              },
              [
                _vm._l(_vm.cardItems, function (item, key) {
                  return _c(
                    "ACarouselSlide",
                    { key: key, attrs: { index: key, "ssr-slide-number": 2 } },
                    [
                      _c("card-item", {
                        attrs: { item: item, filestore: _vm.filestore },
                      }),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm.carouselSettings.pills.value
                  ? _c("div", {
                      staticClass: "swiper-pagination",
                      attrs: { slot: "pagination" },
                      slot: "pagination",
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.carouselSettings.arrows.value
                  ? _c("div", {
                      staticClass:
                        "swiper-button-prev swiper-button-white swiper-arrow",
                      attrs: { slot: "button-prev" },
                      slot: "button-prev",
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.carouselSettings.arrows.value
                  ? _c("div", {
                      staticClass:
                        "swiper-button-next swiper-button-white swiper-arrow",
                      attrs: { slot: "button-next" },
                      slot: "button-next",
                    })
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }